import { ChangeDetectionStrategy, Component, inject, input } from '@angular/core';
import { AiChatComponent } from './ai-chat.component';
import { ChatStateStore } from '../../core/ai-chat';

/**
 * Zero-config wrapper around `<ai-chat>`: provides and injects a `ChatStateStore`, binds
 * its signals to the dumb component, and forwards composer text. The host still provides
 * `CHAT_TRANSPORT` (fake/SSE). Advanced hosts can skip this and wire `<ai-chat>` directly.
 */
@Component({
  selector: 'ai-chat-connected',
  imports: [AiChatComponent],
  providers: [ChatStateStore],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <ai-chat
      [messages]="store.messages()"
      [isStreaming]="store.isStreaming()"
      [error]="store.error()"
      [placeholder]="placeholder()"
      [emptyStateText]="emptyStateText()"
      (send)="store.send({ kind: 'text', text: $event })"
    />
  `,
})
export class AiChatConnectedComponent {
  protected readonly store = inject(ChatStateStore);

  readonly placeholder = input<string>('');
  readonly emptyStateText = input<string>('');
}
